import { theme } from '@gympass/yoga';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const Dots = styled.div`
  display: flex;
  gap: calc(10px * 1.5);
  justify-content: center;
  align-items: center;

  span {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background-color: ${theme.colors.lightNew};
    color: ${theme.colors.lightNew};
    &:first-child {
      animation: flashing 1.1s ease-in-out infinite reverse;
      animation-delay: 0s;
    }
    &:nth-child(2) {
      animation: flashing 1.1s ease-in-out infinite reverse;
      animation-delay: 0.5s;
    }
    &:last-child {
      animation: flashing 1.1s ease-in-out infinite reverse;
      animation-delay: 0.8s;
    }
  }
  @keyframes flashing {
    0% {
      background-color: ${theme.colors.lightNew};
    }
    66% {
      transform: scale(1.3);
    }
    100% {
      background-color: ${theme.colors.lightNew};
      filter: brightness(50%);
    }
  }
`;
